import { STU_MATERIAL , LEAVE_SCHOOL} from './api'
import { METHOD, request } from '@/utils/request'
import download from './downloadFile'

export function listCols(materialId){
    return request(
        STU_MATERIAL+'/getColoums',
         METHOD.GET,
        {materialId}
    )
}

export function findAll(params){
    return request(
         STU_MATERIAL+'/list',
         METHOD.GET,
        params
    )
}

export function getStudentMaterialByCode(studentCode){
    return request(
        STU_MATERIAL+'/getStudentMaterialByCode',
        METHOD.GET,
        {studentCode}
    )
}

export function editStudentMaterial(data){
    return request(
        STU_MATERIAL+'/editStudentMaterial',
        METHOD.POST,
        data
    )
}

export function exportExcel(params){
    download(STU_MATERIAL + '/export', params, '学生材料.xlsx')
}

export function listMaterial(){
    return request(
        STU_MATERIAL+'/titleMenu',
        METHOD.GET,
    )
}

export function getAvatar(studentCode){
    return request(
        LEAVE_SCHOOL+'/graduationStudent/getStudentPhoto',
        METHOD.GET,
        {studentCode}
    )
}

export function downloadTemplateFile(params){
    download(LEAVE_SCHOOL + '/downStudentMaterialTemplete', params, '材料认领确认导入模板.xlsx')
}

export function importStudentMaterial(data){
    return request(
        STU_MATERIAL+'/importStudentMaterial',
        METHOD.POST,
        data
    )
}

export function batchStudentMaterial(data){
    return request(
        STU_MATERIAL+'/batchStudentMaterial',
        METHOD.POST,
        data
    )
}